//
//
//
//
//
//
//
//
//
import { buildUrl } from '@tencent/vft-common/url';
import env from '@tencent/vft-common/env';
var _window = window,
    location = _window.location;
export default {
  computed: {
    defaultLink: function defaultLink() {
      return buildUrl('https://pay.video.qq.com/fcgi-bin/qrencode', {
        url: encodeURIComponent(buildUrl(location.href, {
          ptag: 'sharepicqrcode'
        })),
        isNeedShort: 1,
        margin: 2
      });
    },
    qrcodeLink: function qrcodeLink() {
      var url = '';

      try {
        if (env.isIpad || env.isApad) {
          url = window.setting.环境兼容.pad图;
        } else {
          url = window.setting.环境兼容.pc图;
        }
      } catch (e) {
        console.error(e);
      }

      return url;
    }
  },
  created: function created() {
    document.body.style.position = 'relative';
  }
};